import { render, staticRenderFns } from "./ViewTask.vue?vue&type=template&id=0e2a51d0&"
import script from "./ViewTask.js?vue&type=script&lang=js&"
export * from "./ViewTask.js?vue&type=script&lang=js&"
import style0 from "./ViewTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports